import { Box } from "@mui/material";
import React from "react";
import styles from "./buttonSection.module.scss";
import TabButtonGroup from "../../../../components/tabButtonGroup/TabButtonGroup";
import Button from "../../../../components/buttons/Buttons";
import PropTypes from "prop-types";

const ButtonSection = (props) => {
  const {
    selectedTab,
    handleTabClick,
    handleAddDealerClick,
    handleAddGroupClick,
    buttonList,
  } = props;

  return (
    <Box className={styles.buttonGroupWrapper} data-testid="ButtonSection">
      <TabButtonGroup
        buttonList={buttonList}
        handleTabClick={(value) => handleTabClick(value)}
        withIcon={true}
        showCountSection={true}
        selectedTab={selectedTab}
      />

      <Box className={"actionButtonWrapper"}>
        {/* For Future use 
          <Button
          title="Import"
          iconStyle={styles.downloadIcon}
          buttonType="muibtn-secondary-with-icon"
          withIcon={true}
          handleClick={handleImportButtonClick}
        /> */}

        {selectedTab !== 5 ? (
          <Button
            title="Add new dealer"
            iconStyle={styles.plusIcon}
            buttonType="muibtn-primary-with-icon"
            withIcon={true}
            handleClick={handleAddDealerClick}
          />
        ) : (
          <Button
            title="Add new group"
            iconStyle={styles.plusIcon}
            buttonType="muibtn-primary-with-icon"
            withIcon={true}
            handleClick={handleAddGroupClick}
          />
        )}
      </Box>
    </Box>
  );
};
export default ButtonSection;
ButtonSection.propTypes = {
  selectedTab: PropTypes.any,
  handleTabClick: PropTypes.any,
  handleAddDealerClick: PropTypes.any,
  handleAddGroupClick: PropTypes.any,
  buttonList: PropTypes.any,
};
